import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {Invoice} from '../Model'
import {toMoney, toPercentage, toDateTime} from 'helpers/Format'
import {Table} from 'components'
import Report from '../components/Report'

interface Props {
  store?: Store
}

@inject('store')
@observer
class Sales extends PureComponent<Props, object> {
  componentDidMount() {
    this.props.store!.reports.readInvoices()
  }

  render() {
    const {reports} = this.props.store!
    const headers = this.props.store!.UI.isDesktop
      ? ['number', 'date', 'netAmount', 'discount', 'taxAmount', 'total']
      : ['number', 'date', 'total']
    const items = reports.invoices
    return (
      <Report
        header={headers}
        items={items}
        total={(invoices: Invoice[]) =>
          invoices.reduce((sum, item) => item.total + sum, 0)}
        loading={!reports.invoicesLoaded}
        keyExtractor={(invoice: Invoice) => String(invoice.id)}
        format={(invoices: Invoice[]) =>
          invoices.map(invoice => ({
            ...invoice,
            date: toDateTime(invoice.date),
            discount: toPercentage(invoice.discount),
            netAmount: toMoney(invoice.netAmount),
            taxAmount: toMoney(invoice.taxAmount),
            taxBase: toMoney(invoice.taxBase),
            total: toMoney(invoice.total)
          }))}
      />
    )
  }
}

export default Sales



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/Sales.tsx